var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MobHomeFlowCore,{scopedSlots:_vm._u([{key:"banner",fn:function(){return [(_setup.getBackgroundImage)?_c('div',{staticClass:"m-home-banner",style:({ backgroundImage: `url(${_setup.getBackgroundImage})` })}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }